import Framework from "./Framework";

export abstract class ServiceBase {
    protected http = Framework.DefaultHttp;

}
